import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    sv: {
      translation: {
        formSection: {
          size: "Storlek",
          color: "Färg",
          text: "Text",
          symbol: "Symbol",
          symbolPlacement: "Placering",
        },
        symbolPlacement: {
          center: "Centrerad",
          topLeft: "Vänster uppe",
          centerLabel: "Centrerad",
          topLeftLabel: "Vänster övre hörn",
        },
        label: {
          proposedSize: "Föreslagen storlek",
          widthMillimeters: "Bredd (mm)",
          heightMillimeters: "Höjd (mm)",
          row: "Rad",
          selectSymbol: "Välj en symbol",
          confirmOrderAdditions: "Bekräfta beställning - tillägg",
          additional: "Tillägg",
          orderSent: "Beställningen är skickad!",
          orderError: "Hoppsan! Något gick fel med beställningen",
          preview: "Förhandsgranskning",
          general: "Övergripande",
          design: "Utformning",
          additions: "Tillval",
          amount: "Antal:",
          pricePerSign: "Pris per skylt:",
          basePrice: "Grundpris:",
          reflexSurcharge: "Högreflekterande:",
          graffitiSurcharge: "Klotterskydd:",
          totalPrice: "Totalt pris:",
          width: "Bredd:",
          height: "Höjd:",
          color: "Färg:",
          symbol: "Symbol:",
          symbolPlacement: "Placering symbol:",
          amountOfRows: "Antal rader text:",
          reflex: "Reflex:",
          graffitiProtection: "Klotterskydd:",
          mount: "Fäste:",
          typeOfMounting: "Typ av fäste:",
          needsMounting: "Önskas montage:",
          mm: "(mm)",
          textRows: "Textrader",
          companyName: "Namn på företag/BRF:",
          name: "Namn:",
          email: "E-post:",
          phone: "Telefonnummer:",
          orderConfirmation: "Orderbekräftelse",
          contactInformation: "Kontaktuppgifter",
          unitPrice: "À pris:",
          loading: "Beställningen skickas...",
          designYourSign: "Designa din egen skylt",
          howTo: "Hur gör jag?",
          product: "Produkt:",
          customerInformation: "Kunduppgifter:",
          material: "Material:",
          poleDimension: "Stolpdiameter",
          poleDimension2: "Stolpdiameter:",
          typeOfMount: "Typ av klammer",
          amountOfClamps: "Antal klamrar",
          amountOfClamps2: "Antal klamrar:",
          text: "Text:",
          size: "Storlek:",
          rowbreak: "Radbrytning",
        },
        unit: {
          kr: "kr",
          krVat: "kr (exkl moms)",
          st: "st",
          mm: "mm",
          quantityPrice: "á pris:",
          exVat: "(exkl moms)",
        },
        material: {
          extruded: "Strängpressad",
        },
        order: {
          placedOrder: "Nedan är en översikt på din beställning.",
          orderError:
            "Något gick fel med beställningen. Vänligen försök igen eller kontakta oss.",
          downloadConfirmation:
            "Tryck här för att ladda ned en orderbekräftelse",
        },
        field: {
          amount: "Antal",
          amountOfSigns: "Antal skyltar",
          graffitiProtection: "Klotterskydd",
          mount: "Fäste",
          typeOfMounting: "Typ av fäste",
          needsMounting: "Önskas montage",
          companyName: "Namn på företag/BRF",
          name: "Namn",
          email: "E-post",
          phone: "Telefonnummer",
        },
        option: {
          blueWhite: "Blå/Vit",
          yellowRed: "Gul/Röd",
        },
        button: {
          removeRow: "Ta bort rad",
          addRow: "Lägg till textrad",
          addSymbol: "Lägg till symbol",
          close: "Stäng",
          select: "Välj",
          back: "Tillbaka",
          order: "Beställ",
          backToWebsite: "Gå tillbaka till hemsidan",
          continueDesigning: "Fortsätt designa",
          designNewSign: "Designa en ny skylt",
          next: "Nästa",
          sendOrder: "Skicka beställning",
          newDesign: "Börja designa",
          downloadOrderConfirmation: "Ladda ned orderbekräftelse",
        },
        badge: {
          normal: "Normal",
          high: "Hög",
          yes: "Ja",
          no: "Nej",
          pole: "Stolpe",
          wall: "Vägg",
        },
        color: {
          white: "Vit",
          red: "Röd",
          black: "Svart",
          blue: "Blå",
          yellow: "Gul",
        },
        enum: {
          Normal: "Normal",
          High: "Hög",
          Pole: "Stolpe",
          Wall: "Vägg",
        },
        select: {
          SingleMount: "Enkelklammer",
          DoubleMount: "Dubbelklammer",
        },
        validation: {
          companyName: "Fyll i namn på företag/BRF",
          name: "Fyll i namn",
          email: "Fyll i e-postadress",
          phone: "Fyll i telefonnummer",
          phoneFormat: "Fyll i ett giltigt telefonnummer",
          emailFormat: "Fyll i en giltig e-postadress",
          mountingPoint: "Välj typ av fäste",
        },
        generalText: {
          orderConfirmationInfo:
            " Observera att den färdiga skylten kan avvika något från den digitala förhandsvisningen.",
        },
        error: {
          textFieldMaxLength:
            "Max antal tecken uppnått. Öka skyltens storlek eller minska textstorleken.",
        },
        tooltip: {
          signSize: "En eller flera textrader är för långa",
          signSizePt2:
            "- eller så finns det för många textrader för att välja denna storlek.",
        },
        popover: {
          size: {
            pt1: "Tilläggsskyltar ska ha samma",
            pt2: "bredd",
            pt3: "som den skylt de monteras under. Här är vanliga standardmått:",
            pt4: "P-skyltar (E-skyltar):",
            pt5: "400 mm breda",
            pt6: "Varningsskyltar (A-skyltar, trianglar):",
            pt7: "600 mm breda",
            pt8: "Förbud/uppmaning (C- och D-skyltar, cirklar):",
            pt9: "600 mm breda",
            pt10: "Om du är osäker, mät bredden på huvudskylten innan du beställer!",
            pt11: "Se exempel nedan på hur en tilläggsskylt kan kombineras med ett vägmärke:",
          },
          text: {
            pt1: "För att säkerställa god läsbarhet bör texten på tilläggstavlor vara minst",
            pt2: "60 mm",
            pt3: " hög.",
            pt4: "Detta är särskilt viktigt för att trafikanter ska kunna ta del av informationen på ett säkert sätt.",
          },
          mounting: {
            pt0: "Skylten monteras på en stolpe.",
            pt1: "Enkel klammer -",
            pt2: "fäster skylten på",
            pt3: "en sida",
            pt4: "av stolpen",
            pt5: "Dubbelklammer -",
            pt6: "fäster en skylt på",
            pt7: "båda sidorna",
            pt8: "av stolpen, en på varje sida",
            pt9: "Dubbelklammer är användbart om du behöver ha två skyltar på samma stolpe, en per sida.",
          },
          mount: {
            pt1: "Skylten monteras på stolpar med hjälp av klamrar. Välj:",
            pt2: "Stolpdiameter:",
            pt3: "Välj rätt mått utifrån din stolpe",
            pt4: "Klammer:",
            pt5: "Enkel -",
            pt6: "fäster en skylt på ena sidan av stolpen",
            pt7: "Dubbel -",
            pt8: "fäster en skylt på vardera sidan av stolpen",
            pt9: "Antal klamrar:",
            pt10: "Rekommenderat är minst 2 per skylt för stabil montering",
            pt11: "Dubbelklammer är användbar när du vill montera två skyltar på samma stolpe – en på varje sida",
          },
        },
        textTemplate: {
          landingPageHeaderSection: {
            pt1: "Här kan du designa din egen tilläggstavla. Du kan anpassa din skylt genom att välja färg, storlek, symbol, text etc.",
            pt2: "Skyltarna är anpassade för stolpmontage.",
          },
          landingPageBottomSection: {
            pt1: "Börja med att välja vilken skylt du vill utgå ifrån. Du kan välja på",
            pt2: "Blå/vit tilläggstavla",
            pt3: "- passar bra under parkeringsskyltar eller påbudsskyltar",
            pt4: "Gul/röd tilläggstavla",
            pt5: "- passar bra under varnings- eller förbudsmärken",
            pt6: "Klicka på “Börja designa” för att börja anpassa din skylt.",
            pt7: "När du är nöjd med din skylt klickar du på “Beställ”, väljer dina tillval och skickar beställningen.",
            pt8: "ATA kommer att kontakta dig för att bekräfta din order.",
          },
          orderConfirmation: {
            pt1: " Vi har mottagit din beställning och en av våra medarbetare kommer att kontakta dig inom kort för att bekräfta detaljer, leverans och pris.",
            pt2: "Om du har några frågor innan dess är du alltid välkommen att kontakta oss på",
            pt3: "info@ata.se.",
          },
        },
      },
    },
  },
  lng: "sv",
  fallbackLng: "sv",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
